module.exports = __webpack_public_path__ + "static/ketopersonalplan-994751eeca1b2b0e156de45950361ed1.jpg";